/* SK 2026-10-13 (TD2): replaces jquery-migrate-1.4.1. Only .size() was still used (cart-shipping-calculator). */
(function(){var $=window.jQuery;if($&&!$.fn.size){$.fn.size=function(){return this.length;};}})();
